<template lang="pug">
  table#tbCumplimiento.table.is-striped.is-responsive.is-narrow
    thead
      tr
        th(colspan=5 align="center") Estimado Julio
      tr
        th(align="center") Cliente
        th(align="center") Tons.
        th(align="center") Objetivo
        th(align="center") % Cumplimiento
    tbody
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  {{ verPropangol ? 'Propangol' : 'TexMex' }}
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ verPropangol ? masaEstProp : masaEstTex | numberFormatDecimal}}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium {{ verPropangol ? metaProp : metaTex | numberFormatDecimal }}
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ verPropangol ? porcProp : porcTex }}%
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  Movenergy
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ masaEstMov | numberFormatDecimal }}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium {{ metaMov | numberFormatDecimal }}
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ porcMov }}%
      tr
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium  Total
        td(align="center") 
          span.tag.is-black.is-size-6.has-text-weight-medium {{ masaEstTotal | numberFormatDecimal }}
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium {{ metaTotal | numberFormatDecimal }}
        td(align="center") 
          span.tag.is-black.is-size-6.has-text-weight-medium {{ porcTotal }}%
</template>

<script>
  import moment from 'moment'
  import Decimal  from 'decimal.js'
  
  export default {
    name: 'TbEstimadoMes',
    props: {
      data: {
        type: Object,
        default: () => {},
      },
      dataMetaMensual: {
        type: Array,
        default: () => [],
      },
      fecha: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        daySel: parseInt(moment(this.fecha).format('D')),
        dayLast: parseInt(moment(this.fecha).endOf('month').format('D')),
        masaProp: 0,
        masaMov: 0,
        masaTex: 0,
        masaTotal: 0,
        masaEstProp: 0,
        masaEstMov: 0,
        masaEstTex: 0,
        masaEstTotal: 0,
        porcProp: 0,
        porcMov: 0,
        porcTex: 0,
        porcTotal: 0,
        metaProp: 0,
        metaMov: 0,
        metaTex: 0,
        metaTotal: 0,
        verPropangol: false,
      }
    },
    watch: {
      fecha() {
        this.getData()
      },
      data() {
        this.getData()
      },
      dataMetaMensual() {
        this.getData()
      }
    },
    methods: {
      getData() {
        if (this.fecha !== '') {
          this.daySel = parseInt(moment(this.fecha).format('D'))
          this.dayLast = parseInt(moment(this.fecha).endOf('month').format('D'))
        }

        if (Object.keys(this.data).length > 0) {
          this.masaProp = this.data.masaProp
          this.masaMov = this.data.masaMov
          this.masaTex = this.data.masaTexMex
          const masaP = new Decimal(this.masaProp)
          const masaM = new Decimal(this.masaMov)
          const masaT = new Decimal(this.masaTex)
          this.masaTotal = masaP.plus(masaM).plus(masaT)
          const resultMProp_D = masaP.dividedBy(this.daySel).times(this.dayLast).toFixed(0)
          const resultMProp_D_Dec = masaP.dividedBy(this.daySel).times(this.dayLast)
          this.masaEstProp = resultMProp_D
          
          const resultMMov_D = masaM.dividedBy(this.daySel).times(this.dayLast).toFixed(0)
          const resultMMov_D_Dec = masaM.dividedBy(this.daySel).times(this.dayLast)
          this.masaEstMov = resultMMov_D

          const resultMTex_D = masaT.dividedBy(this.daySel).times(this.dayLast).toFixed(0)
          const resultMTex_D_Dec = masaT.dividedBy(this.daySel).times(this.dayLast)
          this.masaEstTex = resultMTex_D

          this.masaEstTotal = resultMProp_D_Dec.plus(resultMMov_D_Dec).plus(resultMTex_D_Dec).toFixed(2)
        }
        if (this.dataMetaMensual.length > 0) {
          const dataProp = this.dataMetaMensual.find( m => m.compania == 1)
          const dataMov = this.dataMetaMensual.find( m => m.compania == 2)
          const dataTex = this.dataMetaMensual.find( m => m.compania == 2)
          const metaProp = new Decimal(dataProp.meta)
          const metaMov = new Decimal(dataMov.meta)
          const metaTex = new Decimal(dataTex.meta)
          this.metaProp = metaProp
          this.metaMov = metaMov
          this.metaTex = metaTex
          this.metaTotal = metaProp.plus(metaMov).plus(metaTex)

          const masaEstProp = new Decimal(this.masaEstProp)
          const masaEstMov = new Decimal(this.masaEstMov)
          const masaEstTex = new Decimal(this.masaEstTex)
          
          this.porcProp = masaEstProp.dividedBy(metaProp).times(100).toFixed(2)
          this.porcMov = masaEstMov.dividedBy(metaMov).times(100).toFixed(2)
          this.porcTex = masaEstTex.dividedBy(metaTex).times(100).toFixed(2)

          const masaEstTotal = new Decimal(this.masaEstTotal)
          const metaTotal = new Decimal(this.metaTotal)
          this.porcTotal = masaEstTotal.dividedBy(metaTotal).times(100).toFixed(2)

        }
        this.verPropangol = moment(this.fecha).isBefore('2021-08-20')
      },
    },
    created () {
      this.getData()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/dashboard/componentes/Tb_EstimadoMes.vue